<template>
	<div>
		<div class="tw-text-3xl tw-font-bold" v-if="!isDone && !isFinished">
			{{ $t('integrations.import-orders-title', { marketplace: marketplaceName }) }}
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold">{{ $t('integrations.orders-imported') }}</div>
			<div
				class="'tw-border-secondary-500 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-secondary-500 tw-text-white"
				style="width: 32px; height: 32px"
			>
				<AppIcon name="check" />
			</div>
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.import-orders-description', { marketplace: marketplaceName }) }}
		</div>
		<div class="tw-mt-5" v-if="!isDone && !isFinished">
			<AppButton
				:label="loading ? $t('integrations.importing') : $t('integrations.import-orders')"
				size="xl"
				endIcon="assets/v2/image/icons/upload.svg"
				class="tw-rounded-full"
				:disabled="loading"
				@click="reImport"
			/>
		</div>
		<div class="tw-mt-5 tw-flex tw-items-center tw-gap-3" v-else>
			<AppButton
				:label="$t('integrations.re-import-orders')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				secondary
				variant="gray"
				endIcon="assets/v2/image/icons/upload.svg"
				:disabled="loading || isFinished"
				@click="reImport"
			/>
			<AppButton
				:label="$t('integrations.complete-setup')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/check.svg"
				@click="nextStep"
				:disabled="nextStepLoading || isFinished"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { marketplaceStepStatusEnum } from '../../helper';
import { Marketplace } from '../../../../entities/marketplace';
import { useRouter } from 'vue-router';

const linkMarketplaceStore = useLinkMarketplaceStore();

const router = useRouter();

const loading = ref(false);
const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);
const nextStepLoading = ref(false);

const marketplaceName = computed(() => {
	return linkMarketplaceStore.marketplace.name || '';
});

const isFinished = computed(() => {
	return linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Finished;
});

const reImport = async () => {
	loading.value = true;
	isDone.value = false;
    const res = await Marketplace.importOrders(linkMarketplaceStore.linkedMarketplaceId);
    if (res?.data?.success) {
        await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
        await linkMarketplaceStore.refetchSteps();
        isDone.value = true;
    }
};

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
		isDone.value = true;
		router.push('/v2/integrations/marketplaces');
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
